export const routes = {
  audit: {
    index: '/audits',
    details: '/audits/:auditId',
    settings: '/audits/:auditId/settings',
    eaBackgroundForm: '/audits/:auditId/energy-audit/forms/background',
    eaChecklistForm: '/audits/:auditId/energy-audit/forms/checklist',
    eaMechanicalForm: '/audits/:auditId/energy-audit/forms/mechanical',
    eaMechanicalFormEntry:
      '/audits/:auditId/energy-audit/forms/mechanical/:index',
    create: '/audits/create',

    getDetailsPath: (auditId: string) => `${routes.audit.index}/${auditId}`,
    getEnergyAuditFormPath: (auditId: string, formId: string) =>
      `${routes.audit.index}/${auditId}/energy-audit/forms/${formId}`,

    getEnergyAuditBackgroundFormPath: (auditId: string) =>
      routes.audit.getEnergyAuditFormPath(auditId, 'background'),

    getEnergyAuditWaterFixtureFormPath: (auditId: string) =>
      routes.audit.getEnergyAuditFormPath(auditId, 'water-fixture'),

    getEnergyAuditLightingFormPath: (auditId: string) =>
      routes.audit.getEnergyAuditFormPath(auditId, 'lighting'),

    getEnergyAuditLightingCountFormPath: (auditId: string) =>
      routes.audit.getEnergyAuditFormPath(auditId, 'lighting-count'),

    getEnergyAuditMechanicalFormPath: (auditId: string) =>
      routes.audit.getEnergyAuditFormPath(auditId, 'mechanical'),

    getEnergyAuditMechanicalFormEntryPath: (
      auditId: string,
      entryIndex: number,
    ) =>
      `${routes.audit.getEnergyAuditMechanicalFormPath(auditId)}/${entryIndex}`,

    getEnergyAuditChecklistFormPath: (auditId: string) =>
      routes.audit.getEnergyAuditFormPath(auditId, 'checklist'),

    getSettingsPath: (auditId: string) =>
      `${routes.audit.index}/${auditId}/settings`,
  },

  userProfile: {
    index: '/user-profile',
  },

  appSettings: {
    index: '/app-settings',
  },
};
